/** Proposed terms are separate from existing subscription identifiers and grants. */
export const STUDY_TERMS = {
  freeDaily: 3,
  premiumDaily: 50,
  monthlyMinor: 999,
  annualMinor: 7999,
  trialDays: 3,
  annualLookupKey: "inquira_premium_annual_50_v1",
  premiumBenefit: "50 AI Tutor Questions Every Day + Full Premium Study Access.",
} as const;

export const PROPOSED_CREDIT_PACKS = [
  { pack_id: "quick_boost", name: "Quick Boost", questions: 10, price_minor: 99 },
  { pack_id: "study_boost", name: "Study Boost", questions: 25, price_minor: 199 },
  { pack_id: "exam_prep_boost", name: "Exam Prep Boost", questions: 75, price_minor: 499 },
] as const;

export interface StudyUsage {
  count: number;
  limit: number;
  credits: number;
  premium: boolean;
  legacy: boolean;
  resetAt: string;
  enforcementEnabled: boolean;
  complimentaryScansRemaining: number;
  reservedDaily?: number;
  reservedCredits?: number;
  creditsEnabled?: boolean;
}

export function nextUtcReset(now: Date): string {
  return new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + 1)).toISOString();
}

export function questionSource(used: number, reservedDaily: number, limit: number, credits: number, reservedCredits: number): "daily" | "credit" | "legacy" | null {
  if (limit === -1) return "legacy";
  if (used + reservedDaily < limit) return "daily";
  return credits - reservedCredits > 0 ? "credit" : null;
}

export function creditPurchaseReady(pack: { enabled: boolean; stripe_verified: boolean; apple_verified: boolean; google_verified: boolean; stripe_price_id: string | null; apple_product_id: string | null; google_product_id: string | null }, provider: "stripe" | "apple" | "google"): boolean {
  return pack.enabled && pack[`${provider}_verified`] && Boolean(provider === "stripe" ? pack.stripe_price_id : provider === "apple" ? pack.apple_product_id : pack.google_product_id);
}